const generatedAppEnv = {
  AGENT_CHAT_MESSAGES_ENDPOINT: "https://agent.v2.helu.ninja/chat/stream",
  ANALYTICS_API_HOST: "https://api-eu.mixpanel.com",
  ANALYTICS_API_TOKEN: "1cc18a66211dcb7ed9f3ad4c61922103",
  ANALYTICS_ENABLED: true,
  APP_NAME: "main",
  AUTH_CLIENT_ID: "mainapp",
  AUTH_REALM: "helu",
  AUTH_SERVER_URL: "https://auth.v2.helu.ninja",
  BUILD_TYPE: "development",
  ENVIRONMENTAL_VARIABLES_ENDPOINT: "https://config.helu.io",
  FEATURE_TOGGLES_DEV_MODE_ENABLED: true,
  FEATURE_TOGGLES_FEATURES_ENDPOINT: "https://ft.helu.io/api/features/sdk-Pp1hSGmihMCdvY",
  GENERATES_SOURCEMAP: true,
  GRAPHQL_API_ENDPOINT: "https://api.v2.helu.ninja/graphql/",
  LOGGING_CLIENT_TOKEN: "pubd8a637bd6b953bf21d126ec1105e2e02",
  LOGGING_ENABLED: true,
  LOGGING_WITHOUT_TRACE_ID_ENABLED: true,
  PAYMENT_CHARGEBEE_SCRIPT_URL: "https://js.chargebee.com/v2/chargebee.js",
  PAYMENT_CHARGEBEE_SITE: "helu-test",
  PAYMENT_PRICING_TABLE_ID: "prctbl_1Rlm7hA22JTZmS1yAYWUFKKY",
  PAYMENT_PUBLISHABLE_KEY: "pk_test_Y3ckqOnzVIUne6Vk4N707uZs00C4CEtnmS",
  PAYMENT_SCRIPT_URL: "https://js.stripe.com/v3/pricing-table.js",
  PROXY_ENDPOINT: "X",
  RUM_APPLICATION_ID: "4f81e803-1c70-45d1-99ae-a5ea7617d7c4",
  RUM_CLIENT_TOKEN: "pub3e08247adef6322ef5e5d39b00561e1d",
  RUM_ENABLED: false,
  RUM_SERVICE: "main-app",
  RUM_SESSION_REPLAY_SAMPLE_RATE: 0,
  RUM_SESSION_SAMPLE_RATE: 20,
  RUM_SITE: "datadoghq.eu",
  RUM_TRACE_SAMPLE_RATE: 20,
  SOCKET_ENDPOINT: "https://api.v2.helu.ninja",
  TRACKING_ENABLED: false,
  TRACKING_ID: 0,
  USER_GUIDANCE_WORKSPACE_CODE: "YIxnCuXspL750gD2",
  USES_DEPENDENCY_SOURCE_FILES: false,
  VISUALISATION_AGENT_ENDPOINT: "https://agent.v2.helu.ninja/visualisation/agent"
};

export default generatedAppEnv;
